import { onMount } from "solid-js";

export default function TrafficStarsScript() {
  onMount(() => {
    const trafficstarsScript = document.createElement("img");
    trafficstarsScript.src =
      "//tsyndicate.com/api/v1/retargeting/set/fae13064-a2be-40c4-881d-bead9a0e4166";
    trafficstarsScript.height = 1;
    trafficstarsScript.width = 1;
    document.body.appendChild(trafficstarsScript);
  });

  return null;
}
